import React, { FC } from 'react';
import Link from 'next/link';
import { Box } from '@mui/material';
import { createOwnEventBlockStyles } from './create-own-event-block.styles';
import { CoreButton, useStyles } from '@sweatpals/react-ui-kit';

type CreateOwnEventSectuonProps = {
	primaryColor?: string;
};

const CreateOwnEventSection: FC<CreateOwnEventSectuonProps> = ({ primaryColor }) => {
	const styles = useStyles(createOwnEventBlockStyles, primaryColor);

	return (
		<Box sx={styles.launchOwnEventBlock}>
			<Box sx={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
				<Box sx={styles.launchOwnEventIconContainer}>
					🚀
				</Box>
				<Box sx={styles.launchOwnEventTextContainer}>
					Launch your event or community on <br />
					SweatPals,
					<Box component="span">
						it's free
					</Box>
				</Box>
			</Box>
			<Box>
				<Link href='/create/event' legacyBehavior>
					<CoreButton sx={styles.launchOwnEventButton}>
						Create your event
					</CoreButton>
				</Link>
			</Box>
		</Box>
	);
};

export default CreateOwnEventSection;
